<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between align-items-center">
        <h1>{{ $tc($translate.NewTest) }}</h1>
        <router-link :to="{ name: 'home' }"
          ><i class="fa fa-chevron-left"></i
        ></router-link>
      </b-col>
    </b-row>
    <hr />
    <test-form />
  </div>
</template>

<script>
import TestForm from "@/components/tests/TestForm";
export default {
  components: { TestForm }
};
</script>
